<div class="form-group">
  <q9-content-loader [isLoading]="(loading$ | async)"></q9-content-loader>

  <ng-container *ngIf="!(loading$ | async)">
    <div mat-dialog-content #scrollContainer class="content">
      <div class="filters-list">
        <mat-accordion>
          <ng-container [formGroup]="filterListForm">
            <ng-container
              formArrayName="filters"
              *ngFor="let control of getFreshFilters(); let filterIndex = index">
              <ng-container *ngIf="!isCombined(control); else combinedFilter">
                <app-filter-item
                  class="filter-item"
                  [filterControl]="control"
                  [columns]="columns"
                  [showAdd]="isMultiUse(control)"
                  (addSameType)="addToCombineGroup($event)"
                  (delete)="onRemove(filterIndex)"></app-filter-item>
              </ng-container>
              <ng-template #combinedFilter>
                <ng-container
                  *ngIf="
                    !renderedCombinedFilter[control.getRawValue().column] &&
                    combinedFilterDictionary[control.getRawValue().column] as combinedFilters
                  ">
                  <div
                    *ngIf="combinedFilters.length && markRendered(control.getRawValue().column)"
                    class="combined-filter-container">
                    <span>{{control.getRawValue().columnUI}} filter:</span>
                    <app-filter-item
                      *ngFor="let combinedFilter of combinedFilters; let last = last"
                      class="filter-item"
                      [showAdd]="last"
                      [filterControl]="combinedFilter.control"
                      [columns]="columns"
                      (addSameType)="addToCombineGroup($event)"
                      (delete)="onRemove(combinedFilter.at)"></app-filter-item>
                  </div>
                </ng-container>
              </ng-template>
            </ng-container>
          </ng-container>
        </mat-accordion>

        <mat-card *ngIf="columns.length" [class.glow-blue]="glowCard" class="new-filter-section">
          <mat-card-subtitle>{{ 'RUBIC_CUBE.ADD_FILTER_SUBTITLE' | translate }}</mat-card-subtitle>

          <mat-card-content class="new-filter-config">
            <app-edit-filter-form
              [action]="'add'"
              [columns]="columnsWithoutFilters"
              [filter]="newFilterPresetControl.getRawValue()"
              [filterControl]="newFilterFormControl"></app-edit-filter-form>
          </mat-card-content>

          <mat-card-actions class="right-side">
            <q9-primary-button [disabled]="newFilterFormControl.invalid" (click)="onAdd()">
              {{ 'POPUPS.ADD' | translate }}
            </q9-primary-button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>

    <mat-dialog-actions class="right-side">
      <q9-secondary-button (click)="cancel()">{{ closeBtn | translate }}</q9-secondary-button>

      <q9-primary-button (click)="submit()" [disabled]="!this.filters.valid">
        {{ 'GENERAL.CONFIRM_BTN' | translate }}
      </q9-primary-button>
    </mat-dialog-actions>
  </ng-container>
</div>
